import React from 'react';
import { motion } from 'framer-motion';
import Icon from './Icons';
import { ASSURANCE_AUDIT, ASSURANCE_BUSINESS } from '../data/catalog';

const CardGrid = ({ items }) => (
  <div className="zt-grid cols-4">
    {items.map((a, i) => (
      <motion.div
        key={a.h}
        className="zt-card"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
      >
        <Icon name={a.icon} className="zt-icon" size={34} />
        <h4>{a.h}</h4>
        <p>{a.p}</p>
      </motion.div>
    ))}
  </div>
);

const Assurance = () => (
  <section className="band band-line" id="assurance">
    <div className="wrap">
      <motion.div
        className="section-head"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="eyebrow-dark">Audit, Assurance &amp; Advisory</span>
        <h2>Independent audit and assurance across finance, controls, code and vendors</h2>
        <p>
          Internal audit, external audit and financial audit alongside IT-audit, code-review and
          vendor-governance services &mdash; plus licensed accounting, tax and business-advisory
          activities. Independent evidence for boards, regulators and stakeholders that finances,
          controls, code and platform choices are sound.
        </p>
      </motion.div>

      <h3 className="assurance-subhead">Audit &amp; Assurance</h3>
      <CardGrid items={ASSURANCE_AUDIT} />

      <h3 className="assurance-subhead">Finance, Tax &amp; Business Services</h3>
      <CardGrid items={ASSURANCE_BUSINESS} />
    </div>
  </section>
);

export default Assurance;
